<svelte:options accessors/>
<script lang="ts">
    import SlideOver from "../layout/SlideOver.svelte";
    import Title from "../atoms/Title.svelte";
    import Accordion from "../layout/Accordion.svelte";
    import type {IMaintenanceDetail} from "../../data";

    export let open: boolean = false;
    export let details: IMaintenanceDetail;
</script>
<SlideOver bind:open={open} maxWidth="350px">
    {#if details}
        <Title title="Revisión de {details.kilometros_show}" on:click={()=> open = false}/>
        <div class="py-1 mt-1">
            <p>{details.descripcion}</p>
        </div>
        <Accordion title="Se realizará" open="true">
            <table class="revision-table w-100">
                {#each details.que_se_realizara as service}
                    <tr>
                        <td>{service}</td>
                    </tr>
                {/each}
            </table>
        </Accordion>
        <Accordion title="Repuestos incluídos">
            <table class="revision-table w-100">
                {#each details.repuestos_incluidos as part}
                    <tr>
                        <td>{part}</td>
                    </tr>
                {/each}
            </table>
        </Accordion>
    {/if}
</SlideOver>
<style>
    .revision-table td {
        padding:.5rem;
        font-size: 16px;
        font-weight: 300;
    }

    .revision-table tr:nth-child(odd) td{
        background: var(--bg-gray);
    }
</style>